import { EMPTY_ARRAY } from 'commons-ui';
import usePermission from 'commons-ui/src/permission/usePermission';
import { USER_PROFILE_ACL_ACTIONS, USER_PROFILE_RESOURCES, PAGE_NAMES } from '../../../../constant';

export const makeActionList = () => {
	const { hasPermission } = usePermission();
	return {
		rowActions: EMPTY_ARRAY,
		bulkActions: EMPTY_ARRAY,
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					configPageName: PAGE_NAMES.userProfile,
					configResourceName: USER_PROFILE_RESOURCES.previousTickets,
					configActionName: USER_PROFILE_ACL_ACTIONS.createHelpdeskTicket
				});
			}
		}
	};
};

export default {
	makeActionList
};
